import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import CityIcon from "../../Icons/CityIcon";
const CityListComponent = loadable(
  () => import("../../components/City/CityList")
);

const CityList = () => {
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["cities"],
    navigateURL: null,
  });

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.LOCATION}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CityIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>City</span>
      </div>
      <CityListComponent handleIsActive={handleIsActive} />
    </>
  );
};

export default CityList;
